
/**
 * zendesk 获取当前语言
 * @returns {string}，返回 zendesk 语言
 */
export function getZenLan(lang) {
  const zenLan = {
    "zh-CN": 'zh-cn',
    "zh-HK": 'zh-tw',
    en: 'en-us',
    ja: 'ja',
    ko: 'ko-kr',
    ru: 'ru',
    vi: 'vi',
    th: 'th',
  };
  return zenLan[lang] || 'en-us';
}

/**
 * zendesk 获取对应链接
 * @param key，对应的内容key
 * @returns {string}，链接地址
 */
export function getZenLink(lang, key, subfix) {
  const domain = 'https://spikex.zendesk.com/hc/' + getZenLan(lang);
  const links = {
    // 官方公告
    blog: '',
    // 帮助中心
    help: '',
    // 官方群组
    group: '#',
    // 提交工单
    request: '/requests/new',
    // 关于我们
    aboutus: '/sections/900000084183',
    // 联系我们
    contactus: '/articles/',
    // 用户协议
    agreement: '/articles/900001631023',
    // 执法协议
    articles: '/articles/900002362886',
    // 用户协议2
    agreement2: '/articles/900001631023',
    // 隐私条款
    privacy: '/articles/900001630823',
    // 隐私条款2
    privacy2: '/articles/900001630823',
    // 法律申明
    law: '/articles/360046992393',
    // 服务费率
    fees: '/articles/900000407683',
    // OTC服务协议
    'otc-ruler': '/articles/900001657543',
    // C2C服务协议
    'c2c-ruler': '/articles/900001657543',
    // 活期宝规则
    'huoqi-ruler': '/articles/360037798253',
    // 定期宝规则
    'dingqi-ruler': '/articles/360037797853',
    // OTC申请
    'otc-apply': 'http://cz2imcbxucr2.mikecrm.com/ZtwKt',
    // APP下载
    app: '#',
    // API文档
    api: 'https://github.com/xtpub/api-doc',
    // 认购协议
    token: '#',
    // 白皮书
    whitepaper: '',
    // 常见问题
    'Q&A': '/sections/900000093786',
    // XT媒体工具包
    mediaToolkit: '/articles/4407228924057',
    // Futures Guide
    futuresGuide: '/categories/10304829351961',
    // 漏洞赏金
    bugAward: '/articles/17882128272409',
  };

  return domain + (links[key] || '') + (subfix || '');
}

/** 用户协议 / 隐私条款：与 ssr-web-user-center Register（asd-49682 Zendesk）一致 */
const ZENDESK_UA_BASE = 'https://spikex.zendesk.com/hc/';
const ZENDESK_UA_ARTICLE = {
  agreement: '5158356356894',
  privacy: '5158509865246',
};

/**
 * @param {'agreement' | 'privacy'} doc
 * @returns {string}
 */
export function getLegalDocZenLink(lang, doc) {
  const article = ZENDESK_UA_ARTICLE[doc] || ZENDESK_UA_ARTICLE.agreement;
  return `${ZENDESK_UA_BASE}${getZenLan(lang)}/articles/${article}`;
}
